import React, { useState } from "react";
import QuestionList from "./questionList";
import Question from "./question";
import Latex from "../latex";

const ViewQuestion = (props: any) => {
  const { totalQst, questions, answers, attempts, setQIndex, finalIdx } = props;
  let totalCorrectCount = 0;
  let firstCorrectCount = 0;

  questions.map((obj: any) => {
    let correctAns =
      answers[obj._id] && answers[obj._id].ans && answers[obj._id].ans === true
        ? true
        : false;
    if (correctAns) {
      totalCorrectCount++;
    }
    if (obj.retries - attempts[obj._id] === 1 && correctAns) {
      firstCorrectCount++;
    }
    //himanshu added this
    return false;
  });

  const [qst, setQst] = useState(false);
  const firstPercent = Math.round((firstCorrectCount / questions.length) * 100);
  const percent = Math.round((totalCorrectCount / questions.length) * 100);

  return (
    <React.Fragment>
      <div className="progress-align progress_subtitle">
        {firstCorrectCount} of {totalQst} questions are correct on first attempt
        ({firstPercent}%).
      </div>
      <div className="progress-align progress_subtitle">
        {totalCorrectCount} of {totalQst} questions are correct including all tries
        ({percent}%).
      </div>

      <div
        className="alert alert-secondary progress-align progress_subtitle"
        role="alert"
        style={{"display":"none"}}
      >
        You have reached {totalCorrectCount} of {totalQst} point(s), ({percent}
        %)
      </div>
      <div className="p-2 bd-highlight progress-align">
        <button
          type="button"
          className="buttonQuiz green-buttonquiz"
          onClick={() => setQst(!qst)}
        >
          {qst ? "Hide" : "View"} Questions
        </button>
      </div>
      {qst && (
        <div>
          <QuestionList
            questions={questions}
            setQIndex={setQIndex}
            idx={finalIdx}
            preview={true}
          />
          <hr />
          {questions.map((question: any, idx: number) => {
            return (
              <Latex>
                <Question
                  key={idx}
                  question={question}
                  idx={idx}
                  count={questions.length}
                  preview={true}
                  qId={question._id}
                />
              </Latex>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};

export default ViewQuestion;
